import React, {useEffect, useState} from "react";
import {clockTrackingDataInterface} from "../../../API/request/clockTimingInterface";
import {ModusContentMap} from "./helper/modusContent";

interface ClockProps {
    data: clockTrackingDataInterface;
}

const Clock = ({data}: ClockProps) => {

    const isWorkActive = data.Modus === "Working";
    const isPauseActive = data.Modus === "Pause";


    const parseTimeToSeconds = (timeString: string): number => {
        const [h = "0", m = "0"] = timeString.split(":");
        return parseInt(h) * 3600 + parseInt(m) * 60;
    };

    const formatTime = (seconds: number): string => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
    };

    const [workSeconds, setWorkSeconds] = useState(() => parseTimeToSeconds(data.Work));
    const [pauseSeconds, setPauseSeconds] = useState(() => parseTimeToSeconds(data.pause));


    useEffect(() => {
        // Basiswerte zurücksetzen bei neuem Datensatz
        setWorkSeconds(parseTimeToSeconds(data.Work)); // das hat zu falschen Werten geführt, aber unklar, warum das überhaupt dort war. - parseTimeToSeconds(data.pause))
        setPauseSeconds(parseTimeToSeconds(data.pause));
    }, [data.Work, data.pause]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (data.Modus === "Working") {
                setWorkSeconds((prev) => prev + 60);
            } else if (data.Modus === "Pause") {
                setPauseSeconds((prev) => prev + 60);
            }
        }, 60000);

        return () => clearInterval(interval);
    }, [data.Modus]);


    return (
        <div className="d-flex flex-column gap-2 align-items-center justify-content-center">

            <div className="badge bg-primary-subtle text-muted fw-light fs-6 px-3 py-2 rounded-pill shadow-sm">
                Status: <span className={"text-dark fw-bold"}>{ModusContentMap[data.Modus] ||
                <div>❓ Unbekannt</div>}</span>
            </div>

            <div className="d-flex flex-column gap-2 align-items-center justify-content-center">

                <div
                    className={`d-flex align-items-center gap-2 ${isWorkActive ? "fw-bold fs-1" : "text-muted fs-2"}`}>
                    🛠️ <span>{formatTime(workSeconds)}</span>
                </div>
                <div
                    className={`d-flex align-items-center gap-2 ${isPauseActive ? "fw-bold fs-1 text-warning" : "text-muted fs-2"}`}>
                    🏖️ <span>{formatTime(pauseSeconds)}</span>
                </div>

            </div>
        </div>
    );

};

export default Clock;
